/* eslint-disable react/prop-types */
import React from "react";
import "../App.css";
const RadioButton = (props) => {
  const { key, name, value, checked, setInputText, disabled, labelName } =
    props;
  const onChangeButton = (e) => {
    setInputText(e.target.value);
  };
  return (
    <div className="d-flex">
      <input
        type="radio"
        key={key}
        name={name}
        value={value}
        checked={checked}
        onChange={(e) => onChangeButton(e)}
        className="me-1"
        disabled={disabled}
      />
      {labelName}
    </div>
  );
};
export default RadioButton;
